export default class EntityHelper {

  constructor(name) {
    this.name = name;
  }

  itemSummaryString(list, labelFunc) {
    if (list.length > 6) {
      return `${list.length} ${this.name}`;
    } else if (list.length > 0) {
      return list.map(labelFunc).join(', ');
    } else {
      return `No ${this.name} yet!`;
    }
  }
}